import React from "react";

export const QrcodeIcon = (
    props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
    return (
        <svg viewBox="0 0 65 65" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="m20.8-.001h2.6v7.8h-2.6z" />
            <path d="m26-.001h2.6v2.601h-2.6z" />
            <path d="m31.2-.001h10.4v10.4h2.6v2.6h-10.4v-2.6h5.2v-5.2h-2.601v-2.599h-2.599v2.599h-2.6z" />
            <path d="m-.001-.001v18.2h18.2v-18.2h-18.2zm15.601 15.601h-13v-13h13z" />
            <path d="m46.8-.001v18.2h18.201v-18.2h-18.201zm15.601 15.601h-13.001v-13h13.001z" />
            <path d="m5.199 5.199h7.8v7.8h-7.8z" />
            <path d="m28.6 5.199h2.601v2.6h-2.601z" />
            <path d="m52 5.199h7.801v7.8h-7.801z" />
            <path d="m23.399 7.799h5.201v2.6h-2.6v2.6h2.6v5.2h2.6v5.2h-2.6v-2.599h-2.6v-5.2h-2.601v5.2h2.601v2.599h-5.2v-10.4h2.599z" />
            <path d="m31.2 15.6h2.6v2.6h-2.6z" />
            <path d="m36.399 15.6h2.601v2.6h-2.601z" />
            <path d="m41.6 15.6h2.601v2.6h-2.601z" />
            <path d="m5.199 20.8h7.8v2.599h2.601v2.601h-2.601v2.6h-2.6v-5.201h-5.2z" />
            <path d="m15.6 20.8h2.6v2.6h-2.6z" />
            <path d="m33.8 20.8h2.6v2.6h-2.6z" />
            <path d="m39 20.8h2.6v5.2h-2.6z" />
            <path d="m44.2 20.8h7.8v5.2h-2.6v-2.601h-5.2z" />
            <path d="m57.2 20.8h7.801v2.599h-5.2v2.601h5.2v7.8h-7.801v-2.6h2.601v-2.6h-5.201v-2.6h2.6z" />
            <path d="m18.199 23.399h2.601v5.201h5.2v-5.201h2.6v2.601h7.799v2.6h-7.799v2.6h-5.201v2.6h-13v2.599h-2.6v-7.799h2.6v2.6h7.8v-2.6h-2.599v-2.6h2.599z" />
            <path d="m5.199 26h2.6v2.6h-2.6z" />
            <path d="m41.6 26h2.601v2.6h-2.601z" />
            <path d="m-.001 28.6h5.2v5.2h-2.599v10.4h-2.601z" />
            <path d="m36.399 28.6h2.601v2.601h-2.601z" />
            <path d="m31.2 31.2h5.199v5.199h-2.599v-2.599h-2.6z" />
            <path d="m41.6 31.2h2.601v2.6h-2.601z" />
            <path d="m54.6 33.8h2.601v2.6h-2.601z" />
            <path d="m5.199 36.399h2.6v2.601h5.2v2.6h-2.6v2.6h-2.6v-2.6h-2.6z" />
            <path d="m15.6 36.399h2.6v2.601h-2.6z" />
            <path d="m57.2 36.399h7.801v7.801h-2.6v-5.2h-5.201z" />
            <path d="m54.6 41.6v-5.2h-2.6v-2.6h-2.6v-2.6h2.6v2.6h2.6v-5.2h-5.2v-2.6h-2.6v2.6h-2.6v2.6h2.6v5.199h2.6v5.2h-7.8v-2.599h5.2v-2.601h-5.2v-2.6h-2.6v2.6h-2.601v5.2h-2.6v2.601h-2.6v-2.6h2.6v-5.2h-2.6v2.6h-2.599v-2.601h2.6v-2.6h-7.801v2.6h2.601v2.601h-7.801v2.6h-5.2v2.6h7.801v-2.6h7.8v2.6h-7.8v2.6h5.2v2.6h-2.601v2.6h-2.6v7.801h2.6v-2.601h2.601v-5.2h2.6v-2.6h2.6v-2.6h5.199v-2.6h2.601v5.2h2.6v5.2h-2.6v-5.2h-5.2v2.6h-5.2v5.2h2.6v-2.6h5.199v2.6h5.2v2.601h2.601v-2.601h2.6v-2.6h5.2v2.6h5.2v-2.6h-2.6v-2.6h2.6v-2.6h-2.6v-2.6h2.6v-2.6h2.601v-2.6zm-2.6 10.4h-7.8v-7.8h7.8z" />
            <path d="m59.801 44.2h2.6v2.6h2.6v2.6h-5.2z" />
            <path d="m46.8 46.8h2.601v2.601h-2.601z" />
            <path d="m-.001 46.8v18.201h18.2v-18.201zm15.601 15.601h-13v-13.001h13z" />
            <path d="m5.199 52h7.8v7.801h-7.8z" />
            <path d="m57.2 52h2.601v2.6h-2.601z" />
            <path d="m62.401 54.6h2.6v10.401h-10.401v-2.6h7.801z" />
            <path d="m31.2 57.2h5.199v2.601h-5.199z" />
            <path d="m46.8 57.2h5.2v2.601h2.6v2.6h-5.2v2.6h-5.2v-2.6h2.6z" />
            <path d="m57.2 57.2h2.601v2.601h-2.601z" />
            <path d="m28.6 59.801h2.601v2.601h-2.601z" />
            <path d="m36.399 62.401h5.2v2.6h-5.2z" />
        </svg>
    );
};
